import * as React from 'react';

// tslint:disable:max-line-length
export const PortalCheckoutTermsVIN: React.StatelessComponent = (props) => {
  return (
    <div>
      <p>
        By providing us with your VIN# (Vehicle Identification Number), we will evaluate the vehicle information provided and perform a quick check to ensure that the year, make, and model information matches the items selected. However, it is important to note that providing us with your VIN# does not guarantee that we will ship out the correct parts based solely on the provided VIN information. Ordering the correct parts is the sole responsibility of the person placing the order. PAC (our company) will not be held liable for shipping out any parts that were wrongly selected by the customer, even if the VIN# was provided. We strongly recommend that our customers double-check their order information before submitting it to ensure that the correct parts are ordered. If you place an order without providing your VIN# (Vehicle Identification Number), we reserve the right to charge a 20% restocking fee for all returns accepted within our return policy.
      </p>
    </div>
  );
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/portal/PortalCheckout/PortalCheckoutTermsVIN.tsx